/**
 * Dynamic Style includes
 *
 */

var alertElem = document.querySelector('.c24-alert');
window.fireOnVisible(alertElem, async () => {
    await import('../../frontend/styles/ck24_notification.scss');
});

var gratbarElem = document.querySelectorAll('.gratbar');
window.fireOnVisible(gratbarElem, async () => {
    await import('../../frontend/styles/ck24_gratbar.scss');
});

var couponBarElem = document.querySelectorAll('.coupon-bar');
window.fireOnVisible(couponBarElem, async () => {
    await import('../../frontend/styles/ck24_couponbar.scss');
});

var modalElem = document.querySelectorAll('.ck24_modal');
window.fireOnVisible(modalElem, async () => {
    await import('../../frontend/styles/ck24_modalWindow.scss');
});

var flagElem = document.querySelectorAll('.flag-sprite');
window.fireOnVisible(flagElem, async () => {
    await import('../../frontend/styles/country_flags_as_sprite.scss');
});

var offerTableElem = document.querySelectorAll('.offer-table');
window.fireOnVisible(offerTableElem, async () => {
    await import('../../frontend/styles/offer-table.scss');
});

var starsElem = document.querySelectorAll('.ck24-Stars');
window.fireOnVisible(starsElem, async () => {
    await import('../../frontend/styles/external/ck24_stars.css');
});

var tooltipElem = document.querySelectorAll('.ck24-tooltip');
window.fireOnVisible(tooltipElem, async () => {
    await import('../../frontend/styles/ck24_tooltip.scss');
});

var airlineLogogsElem = document.querySelectorAll('.airline-sprite');
window.fireOnVisible(airlineLogogsElem, async () => {
    await import('../../frontend/styles/airline-logos.scss');
});

var rs = document.querySelectorAll('.ratingSquare');
window.fireOnVisible(rs, async () => {
    await import('../../frontend/styles/ck24_ratingSquare.scss');
});
